export const SUPPORTED_LANGUAGES = ['TR', 'EN', 'RU'];
export const DEFAULT_LANGUAGE = 'TR';

export const normalizeLanguage = (lang) => {
  if (!lang || typeof lang !== 'string') return DEFAULT_LANGUAGE;
  const upper = lang.toUpperCase();
  return SUPPORTED_LANGUAGES.includes(upper) ? upper : DEFAULT_LANGUAGE;
};

export const getStoredLanguage = () => {
  try {
    if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
    const stored = window.localStorage.getItem('language');
    return normalizeLanguage(stored);
  } catch (_) {
    return DEFAULT_LANGUAGE;
  }
};

export const setAppLanguage = (lang) => {
  const normalized = normalizeLanguage(lang);
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('language', normalized);
      const evt = new CustomEvent('app-language-change', { detail: { language: normalized } });
      window.dispatchEvent(evt);
    }
  } catch (_) {
    // ignore storage errors (private mode, etc.)
  }
  return normalized;
};






